export default __webpack_public_path__ + "static/brand-logo-afst-c93199b91d71f09f3146685a5e34f0f2.png";